// extracted by mini-css-extract-plugin
export default {"page":"vZ-z","cartModal":"wZ-z","checkout":"xZ-z","placeholder":"yZ-z","account":"zZ-z"};